<template>
    <div>
    
        <CRow class="m-0 justify-content-center align-items-center">
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Login with Email</span>
                </h5>
    
            </CCol>
            <CCol sm="8" class="text-center mt-3" style="width: 90%;background-size: cover; margin: auto;">
                <!-- Additional content -->
                <div class="p-2 text-left">
                    <label class="custom-14px poppin-font text-left">Email</label>
                    <input type="text" placeholder="Enter your email" class="custom-input-app" v-model="Email"/>

                    <br />
                    <label class="custom-14px poppin-font text-left">Password</label>
                    <input type="password" placeholder="Enter your password" class="custom-input-app" v-model="Password"/>
                    <CRow class="p-2">
                        <div style="width:60%"><input type="radio" class="mr-2"/>Remember Me</div>
                        <div style="width:40%"><a href="ForgotPassword" class="text-right">Forgot Password</a></div>
                      
                       
                    </CRow>
                    <div class="mt-2">
                        <CButton type="button" class="button-border-blue text-white" block v-on:click="trylogin">
                            {{ buttonLabel }}
                        </CButton>
                        <br />
                    </div>
                    <div style="margin:0 auto;" class="text-center m-0">
                            <img style="max-width:100%" src="../assets/img/Or.png" />
                        </div>
                        <CRow>
                            <div style="width:50%">
                            <div class="text-center bg-white b-20 p-2 m-20" style="border:none;margin:10px">
                                <img style="width:25px" src="../assets/img/google.png" class="mt-1 mb-1 mr-2"/>
                                </div>
                            </div>
                            <div style="width:50%">
                                <div class="text-center bg-white b-20 p-2 m-20" style="border:none;margin:10px">
                                    <img style="width:25px" src="../assets/img/apple.png" class="mt-1 mb-1 ml-2"/>
                                </div>
                            </div>
                        
                        </CRow>
                        <div class="text-center">
                           <label class="custom-14px poppin-font"> Don’t have an account?   <CButton color="link" class="px-0" @click="GoToRegister()">Create Account</CButton></label>
                        </div>
                
    
    
                 
                </div>
            </CCol>
        </CRow>
    </div>
</template>


<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,
            Email: "",
      Password: "",
      Error: false,
      Message: "",
      buttonLabel: 'Login',

        }

    },
    methods: {
      GoToPrevious() {
          this.$router.go(-1);
      },
      
      GoToLogin() {
          // Close the popup and backdrop
          this.$router.push("/RegisterHomepage");
      },
      GoToRegister()
      {
        this.$router.push("/RegisterHomepage");
       // this.$router.push("/CreateAccount?countryId=" + this.$route.query.countryId + "&type=" + this.$route.query.type + "&language=" + this.$route.query.language);
      },
      GoToChangePassword() {
          // Close the popup and backdrop
          this.$router.push("/ForgotPassword");
      },
      GoToHomeUser()
      {
          this.$router.push("/HomeUser");
      },

      trylogin() {
      this.Error = false;

      const formData = new FormData();

      if (this.Email === "" || this.Password === "") {
        this.Error = true;
        this.Message = "Please fill up the form !";
      } else {
        this.buttonLabel = 'Processing';
        formData.append("Email", this.Email);
        formData.append("Password", this.Password);

        this.$API
          .post(this.$LoginToken, formData, { withCredentials: true })
          .then((response) => {
            if (response.data.status === 400) {
              this.Loading = false;
              this.Message = response.data.message;
              this.Error = true;
            }
            if (response.status == 200) {
              
              if (response.data.status !== 400) {

                if (
                  this.$route.query.targetUrl != "" &&
                  (this.$route.query.targetUrl != null) &
                    (this.$route.query.targetUrl != undefined)
                ) {
                  this.$router.push(this.$route.query.targetUrl);
                } else {
                  const userId = response.data.data.userId;
                  console.log("userid", userId);
                  this.GoToHomeUser(userId);
                }
                






               
              } else {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;
              }
            } else {
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.message;
            }
          })
          .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    }
})
</script>
